module.exports = __webpack_public_path__ + "img/autosense-product-page-cover-large.2364ce09.png";